import { MutationTree } from 'vuex';
import { StatisticsState, Search, StatisticsList, Statistics } from './types';

export const mutations: MutationTree<StatisticsState> = {
  setSearchDetail(state, payload: Search) {
    state.parameters.startDate = payload.startDate; // 등록일:검색시작일자
    state.parameters.endDate = payload.endDate; // 등록일:검색끝일자
    state.parameters.state = payload.state; // 등록상태
    state.parameters.parkinglotType = payload.parkinglotType; // 주차장 구분
    state.parameters.newExpansion = payload.newExpansion; // 신축 여부
    state.parameters.totalNum = payload.totalNum; // 총주차대수
    state.parameters.bizHourCd = payload.bizHourCd; // 운영시간:평일
    state.parameters.satBizHourCd = payload.satBizHourCd; //운영시간:토요일
    state.parameters.sunHolBizHourCd = payload.sunHolBizHourCd; //운영시간:일요일
    state.parameters.intervalFreeNy = payload.intervalFreeNy; //주차요금구분
  },
  setSearchWord(state, payload: string) {
    state.parameters.searchWord = payload; // 검색단어
  },
  setSearchCategory(state, payload: string) {
    state.parameters.searchCategory = payload; // 검색구분
  },
  setStatisticsList(state, payload: StatisticsList) {
    state.list = payload;
  },
  setPagingOffset(state, payload: number) {
    state.list.paging.offset = payload;
  },
  setStatistics(state, payload: Statistics) {
    state.statistics = payload;
  },
  setSort(state, payload: string) { // 정렬
    state.parameters.sort = payload;
  },
  setScrollBind(state, payload: boolean) {
    state.scrollOptions.scrollBind = payload;
  },
  setScrollCallbackFn(state, payload: Function) {
    state.scrollOptions.callbackFn = payload;
  }
};
//저장소에 데이터를 밀어 넣어줄때 쓰는 곳
//(state, payload: SearchState) = state.(SearchState 데이터 네임) = payload.(SearchState 데이터);